import { lazy } from 'react';
import type { FeatureRoute } from '@/app/registry';

/**
 * Field work: tickets (with 311 and Zendesk lookups) and the technicians who work them. Listed in
 * the Operations menu; the /fieldops paths stay so links and bookmarks keep working.
 */
export const fieldopsRoutes: FeatureRoute[] = [
  {
    path: '/fieldops/tickets',
    title: 'tickets',
    tabs: [
      { key: 'tickets', title: 'tickets', resource: 'ticket', component: lazy(() => import('./tickets/TicketsPage')) },
      { key: 'lookup', title: 'ticketLookup', resource: 'ticket', legacyPath: '/fieldops/ticket-tools', component: lazy(() => import('./tools/TicketToolsPage')) },
    ],
  },
  { path: '/fieldops/technicians', title: 'technicians', resource: 'technician', component: lazy(() => import('./technicians/TechniciansPage')) },
];
